import { Button } from 'antd';
import React from 'react';
import EmptyImg from 'asset/image/home_metting_empty_img@2x.png';
import styles from './index.module.scss';

interface IProps {
  onKnow: () => void;
}

const ContinueResult: React.FC<IProps> = ({ onKnow }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.emptyWrapper}>
        <img className={styles.img} src={EmptyImg} />
        <div className={styles.title}>会议继续</div>
        <div className={styles.desc}>为了更好地利用会议室资源，</div>
        <div className={styles.desc}>请尽快前往开会。谢谢您的配合！</div>
        <Button className={styles.confirm} type="primary" onClick={onKnow}>
        我知道了
      </Button>
      </div>
    </div>
  );
};

export default ContinueResult;
